<template>
    <div class="main"
         v-if="detail"
         :style="{ background: detail.color }">
        <my-nav-bar :bordered="false"
                    :background="detail.color"
                    textColor="#fff"></my-nav-bar>
        <div class="top">
            <div class="info">
                <span class="title">{{ detail.title }} {{ detail.audio && detail.audio.title }}</span>
                <span class="listen">播放：{{ detail.views }}</span>
            </div>
            <div class="cover"
                 v-if="detail.audio">
                <img :src="detail.audio.image || detail.thumb"
                     alt="" />
            </div>
            <div class="ad"
                 v-if="showAd">
                <div class="close"
                     @click="closeAd">关闭广告</div>
                <van-swipe class="my-swipe"
                           :autoplay="3000"
                           indicator-color="#FF5C45">
                    <van-swipe-item v-for="(item, index) in list"
                                    :key="index">
                        <img :src="item.image"
                             alt="" />
                    </van-swipe-item>
                </van-swipe>
            </div>
            <!--            <div class="ad">-->
            <!--                <img src="@/assets/img/live_avatar.jpg" alt="">-->
            <!--            </div>-->
            <div class="operate">
                <div class="funcs">
                    <div class="item"
                         @click="openDownModal">
                        <span class="iconfont icon-download"></span>
                    </div>
                    <!-- <div class="item" @click="openDownModal">
                        <span class="iconfont icon-speed"></span>
                    </div> -->
                    <div class="item"
                         @click="openDownModal">
                        <span class="iconfont icon-bell"></span>
                    </div>
                    <div class="item"
                         @click="openDownModal">
                        <span class="iconfont icon-list"></span>
                    </div>
                </div>
            </div>
            <div class="process">
                <div class="line"
                     :style="{ width: rateNum + 'px' }"></div>
                <div class="rate"
                     :style="{ left: rateNum + 'px' }">
                    {{ passTime | formatTime }}/{{ audioInfo.totalTime | formatTime }}
                </div>
            </div>
            <div class="switch-audio">
                <!--         <span class="iconfont icon-prev" @click="prev"></span>-->
                <div class="play"
                     @click="startPlay">
                    <span class="iconfont icon-play"
                          v-if="status != PLAY"></span>
                    <span class="iconfont icon-pause"
                          v-else></span>
                </div>
                <!--         <span class="iconfont icon-next" @click="next"></span>-->
            </div>
            <div class="anchor"
                 v-if="detail.anchor && detail.anchor.length > 0">
                <span>主播</span>
                <div class="item"
                     v-for="item in detail.anchor"
                     :key="item.userid">
                    <div class="left">
                        <img :src="item.image"
                             alt="" />
                        <span>{{ item.nickname }}</span>
                    </div>
                    <div class="follow"
                         @click="openDownModal">+关注</div>
                </div>
            </div>
        </div>
        <div class="hot-list"
             v-if="detail.recommend && detail.recommend.length > 0">
            <div class="title">热门推荐</div>
            <div class="item"
                 v-for="item in detail.recommend"
                 :key="item.contengid" @click="openDownModal">
                <div class="cover">
                    <img :src="item.image"
                         alt="" />
                    <div class="vip-tag">会员</div>
                    <div class="listen">
                        <span class="iconfont icon-play"></span>
                        {{ item.views }}
                    </div>
                </div>
                <div class="info">
                    <div>
                        <div class="name">{{ item.title }}</div>
                        <div class="sub-title">{{ item.subtitle }}</div>
                    </div>
                    <!--          <div class="chapter">{{ item.sum }}集</div>-->
                </div>
            </div>
        </div>
        <my-bottom-bar />
        <!-- <DownApp /> -->
    </div>
</template>
<script>
import { PLAY, AUDIO, STOP } from "@/global/constant";
import { mapActions, mapState } from "vuex";
import GlobalPlayer from "@/components/GlobalPlayer";
import DownApp from "@/components/DownApp";
import {
    AudioDetailApi,
    AudioDetailInListApi,
    NextAudioApi,
    PrevAudioApi,
    SingleAudioDetailApi,
} from "@/request/api";
import { Toast } from "vant";

export default {
    components: { GlobalPlayer, DownApp },
    data() {
        return {
            PLAY,
            STOP,
            AUDIO,
            rateNum: 0,
            rate: 0,
            process: 0,
            id: null,
            pid: null,
            showAd: false,
            detail: {},
            // 切换中
            changing: false,
        };
    },
    created() {
        this.id = this.$route.query.id || 1820;
        this.getData();
    },
    mounted() {
        this.$nextTick(() => {
            this.rate = document
                .getElementsByClassName("rate")[0]
                .getBoundingClientRect().width;
            this.process = document
                .getElementsByClassName("process")[0]
                .getBoundingClientRect().width;
        });
    },
    methods: {
        ...mapActions({
            setAutoPlayAsync: "audio/setAutoPlay",
        }),
        onclickItem(contentid) {
            SingleAudioDetailApi({ cid: contentid }).then((res) => {
                // AudioDetailApi({ cid: this.id }).then((res) => {
                this.detail = res.data;
                this.globalInitWxShare(
                    this.detail.title,
                    this.detail.subtitle,
                    this.detail.thumb
                );
                this.rateNum = 0;
               
            });

        },
        startPlay() {
            if (this.status == PLAY) {
                this.player.pause();
            } else {
                if (!this.autoPlay) {
                    this.player.play(
                        {
                            id: this.id,
                            name: this.detail.audio.title,
                            url: this.detail.audio.url,
                            poster: this.detail.thumb,
                            type: AUDIO,
                            audioId: this.pid,
                            totalTime: this.transTime(
                                this.detail.audio.playtime
                            ),
                        },
                        this.autoNext
                    );
                    this.setAutoPlayAsync();
                } else {
                    this.player.resume();
                }
            }
        },
        // 下一个
        next() {
            this.nextFunc(() => {
                Toast("没有下一首了");
            });
        },
        autoNext() {
            // 没有下一首停止播放
            this.nextFunc(() => {
                this.player.pause();
            });
        },
        // 下一首的通用部分逻辑
        nextFunc(act) {
            let data = { cid: this.pid, id: this.id };
            NextAudioApi(data).then((res) => {
                // 重设信息
                if (Object.keys(res.audio).length > 0) {
                    this.player.stop();
                    this.detail.audio = res.audio;
                    this.id = this.detail.audio.id;
                    this.player.play(
                        {
                            id: this.id,
                            name: this.detail.audio.title,
                            url: this.detail.audio.url,
                            poster: this.detail.thumb,
                            type: AUDIO,
                            audioId: this.pid,
                            totalTime: this.transTime(
                                this.detail.audio.playtime
                            ),
                        },
                        this.autoNext
                    );
                } else {
                    act();
                }
            });
        },
        // 上一个
        prev() {
            let data = { cid: this.pid, id: this.id };
            PrevAudioApi(data).then((res) => {
                // 重设信息
                if (Object.keys(res.audio).length > 0) {
                    this.player.stop();
                    this.detail.audio = res.audio;
                    this.id = this.detail.audio.id;
                    this.player.play({
                        id: this.id,
                        name: this.detail.audio.title,
                        url: this.detail.audio.url,
                        poster: this.detail.thumb,
                        type: AUDIO,
                        audioId: this.pid,
                        totalTime: this.transTime(this.detail.audio.playtime),
                    });
                } else {
                    Toast("没有上一首了");
                }
            });
        },
        closeAd() {
            this.showAd = false;
        },
        getData() {
            SingleAudioDetailApi({ cid: this.id }).then((res) => {
                // AudioDetailApi({ cid: this.id }).then((res) => {
                this.detail = res.data;
                this.globalInitWxShare(
                    this.detail.title,
                    this.detail.subtitle,
                    this.detail.thumb
                );
                // 开始播放
                if (this.status == STOP) {
                    if (this.autoPlay) {
                        this.player.play({
                            id: this.id,
                            name: this.detail.audio.title,
                            url: this.detail.audio.url,
                            poster: this.detail.thumb,
                            type: AUDIO,
                            audioId: this.pid,
                            totalTime: this.transTime(
                                this.detail.audio.playtime
                            ),
                        });
                    }
                }
            });
        },
        transTime(str) {
            let minutes = parseInt(str.split(":")[0]);
            let second = parseInt(str.split(":")[1]);
            return minutes * 60 + second;
        },
    },
    computed: {
        ...mapState({
            passTime: (state) => state.audio.passTime,
            audioInfo: (state) => state.audio.audioInfo,
            status: (state) => state.audio.status,
            autoPlay: (state) => state.audio.autoPlay,
        }),
    },
    watch: {
        passTime() {
            let width = this.process - this.rate;
            this.rateNum = width * (this.passTime / this.audioInfo.totalTime);
        },
    },
    filters: {
        formatTime(time) {
            let second = "";
            let minutes = "";
            second = time % 60;
            minutes = parseInt(time / 60);
            return `${minutes > 9 ? minutes : "0" + minutes}:${
                second > 9 ? second : "0" + second
            }`;
        },
    },
};
</script>

<style lang="less" scoped>
.main {
    width: 100%;
    min-height: 100vh;
    background-color: @bg-color;
    .top {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 24px 12px 24px;
        .info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 37px;
            .title {
                color: #fff;
                font-size: 18px;
                line-height: 25px;
            }
            .listen {
                font-size: 12px;
                color: #cccccc;
            }
        }
        .cover {
            width: 220px;
            height: 220px;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .ad {
            width: 100%;
            height: 137px;
            position: relative;
            border-radius: 6px;
            .my-swipe {
                width: 100%;
                height: 100%;
                border-radius: 6px;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .close {
                position: absolute;
                right: 0;
                top: 0;
                padding: 4px 8px;
                z-index: 100;
                color: #a7a7a7;
                background-color: rgba(#222222, 0.5);
                font-size: 12px;
                border-radius: 0 6px 0 6px;
            }
        }
        .funcs:extend(.flex-aro) {
            width: 343px;
            margin-top: 32px;
            color: #fff;
            .iconfont {
                font-size: 24px;
            }
            .item {
                height: 40px;
            }
        }
        .process {
            width: 100%;
            height: 1px;
            background-color: rgba(#fff, 0.2);
            position: relative;
            &:before,
            &:after {
                content: "";
                width: 3px;
                height: 3px;
                position: absolute;
                border-radius: 50%;
                background-color: #fff;
                top: -1px;
            }
            &:before {
                left: 0;
            }
            &:after {
                right: 0;
            }
            .line {
                height: 100%;
                background-color: #fff;
            }
            .rate:extend(.flex-cen) {
                background-color: #fff;
                border-radius: 100px;
                position: absolute;
                height: 21px;
                font-size: 10px;
                padding: 0 6px;
                top: -10px;
                //transition: all linear 1s;
            }
        }
        .switch-audio {
            margin: 0 auto;
            margin-top: 30px;
            margin-bottom: 32px;
            display: flex;
            align-items: center;
            .iconfont {
                font-size: 25px;
                color: #ffffff;
            }
            .play:extend(.flex-cen) {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                background-color: #fff;
                margin: 0 46px;
                .iconfont {
                    color: @bg-color;
                    margin-left: 3px;
                }
            }
        }
        // .switch-audio:extend(.flex-btw) {
        //   width: 150px;
        //   margin-top: 30px;
        //   margin-bottom: 32px;
        //   .iconfont {
        //     font-size: 25px;
        //     color: #ffffff;
        //   }
        //   .play:extend(.flex-cen) {
        //     width: 48px;
        //     height: 48px;
        //     border-radius: 50%;
        //     background-color: #fff;
        //     .iconfont {
        //       color: @bg-color;
        //       margin-left: 3px;
        //     }
        //   }
        // }
        .anchor {
            color: #ffffff;
            width: 100%;
            box-sizing: border-box;
            padding: 8px 12px;
            background-color: rgba(#fff, 0.1);
            border-radius: 6px;
            .item:extend(.flex-btw) {
                margin-top: 16px;
                .left:extend(.flex-cen) {
                    font-size: 14px;
                    img {
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        margin-right: 12px;
                    }
                }
                .follow {
                    font-size: 14px;
                    padding: 6px 13px;
                    border-radius: 100px;
                    border: 1px solid #ffffff;
                    .add {
                        font-weight: bold;
                        font-size: 16px;
                        margin-right: 2px;
                    }
                }
                .has {
                    border-color: rgba(#f8f8f8, 0.5);
                    color: rgba(#f8f8f8, 0.5);
                }
            }
        }
    }
    .hot-list {
        width: 100%;
        border-radius: 8px 8px 0 0;
        background-color: #fff;
        box-sizing: border-box;
        padding: 8px 16px;
        .title {
            font-size: 20px;
            line-height: 28px;
            margin-bottom: 16px;
            font-weight: bold;
        }
        .item {
            display: flex;
            margin-bottom: 24px;
            .info {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .name {
                    font-size: 16px;
                    line-height: 22px;
                }
                .sub-title {
                    margin-top: 4px;
                    font-size: 12px;
                    color: #646464;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }
                .chapter {
                    font-size: 10px;
                    color: #a7a7a7;
                }
            }
            .cover {
                min-width: 80px;
                width: 80px;
                height: 80px;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                margin-right: 12px;
                img {
                    width: 100%;
                    height: 100%;
                }
                .vip-tag {
                    border-radius: 6px 0 6px 0;
                    background-color: #d0a85c;
                    font-size: 12px;
                    color: #fff;
                    position: absolute;
                    left: 0;
                    top: 0;
                    padding: 1px 6px;
                }
                .listen {
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    font-size: 12px;
                    color: #ffffff;
                    box-sizing: border-box;
                    padding-right: 6px;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    height: 32px;
                    background: linear-gradient(
                        to top,
                        rgba(#222222, 0.4),
                        rgba(#222222, 0.2),
                        rgba(#fff, 0)
                    );
                    .iconfont {
                        font-size: 10px;
                    }
                }
            }
        }
    }
}
</style>
